import React, {useEffect, useState} from "react";
import {Col} from "antd";
import {ShiftScoreFilterPropTypes} from "./ShiftScoreComponentPropTypes";
import {
    CompanyFilter,
    DatePickerWithPeriod,
    SubCompanyFilter,
    CityFilter
} from "../../_defaultComponents/FilterComponents";
import stores from "../../../store/stores";
import moment from "moment";

const FutureShiftsFilters = ({setCurrentPage, filters, setFilters}: ShiftScoreFilterPropTypes) => {
    const [company, setCompany] = useState(filters.company);
    const [subCompany, setSubCompany] = useState(filters.subCompany);
    const [period, setPeriod] = useState(filters.period);
    const [startDate, setStartDate] = useState(filters.startDate);
    const [endDate, setEndDate] = useState(filters.endDate);
    const [city, setCity] = useState(filters.city);

    useEffect(() => {
        setCurrentPage(1);
    }, [company, subCompany, period, startDate, endDate, city]);

    useEffect(() => {
        const newFilters = {company, subCompany, period, startDate, endDate, city};
        if (JSON.stringify(filters) !== JSON.stringify(newFilters)) {
            setFilters(newFilters);
        }
    }, [company, subCompany, period, startDate, endDate, city]);

    const onChangeCompany = value => {
        setCompany(value);
        setSubCompany([]);
    };

    const onChangeSubCompany = value => {
        if (value[value.length - 1] === "all") {
            setSubCompany(["all"]);
        } else {
            const index = value.indexOf("all");
            index > -1 && value.splice(index, 1);
            setSubCompany(value);
        }
    };

    return (
        <React.Fragment>
            <Col xs={24} sm={12} md={8} lg={8} xl={3}>
                <CityFilter value={city} onChange={setCity} />
            </Col>
            {(stores.meStore.checkRole("userPermission") ||
                stores.meStore.auth?.companies?.length > 1) && (
                <Col xs={24} sm={12} md={6} lg={8} xl={3}>
                    <CompanyFilter
                        value={company}
                        onChange={onChangeCompany}
                        showAllOption={true}
                        showPoolOption={false}
                    />
                </Col>
            )}
            {!["pool", "all"].includes(company) &&
                (stores.meStore.checkRole("userPermission") ||
                    stores.meStore.auth?.subCompany === undefined ||
                    stores.meStore.auth?.subcompanies?.length > 1) && (
                    <Col xs={24} sm={12} md={8} lg={8} xl={3}>
                        <SubCompanyFilter
                            value={subCompany}
                            onChange={onChangeSubCompany}
                            company={company}
                            disabled={false}
                            initialCall={
                                stores.meStore.checkRole("isCompanyUser") ||
                                stores.meStore.orderPage?.filters.companies?.length > 0
                            }
                            mode="multiple"
                        />{" "}
                    </Col>
                )}
            <Col xs={24} sm={20} md={20} lg={16} xl={10}>
                <DatePickerWithPeriod
                    period={period}
                    setPeriod={setPeriod}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    disabledDate={moment()
                        .subtract(1, "day")
                        .endOf("day")}
                    showNextButton={true}
                    showPrevButton={true}
                    showYesterday={false}
                />
            </Col>
        </React.Fragment>
    );
};

export default FutureShiftsFilters;
